import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        // Um 401 na própria tentativa de login (senha errada) não é sessão
        // expirada — não deslogar nem navegar, ou o "?r=" da tela de login
        // (destino após autenticar) se perde e a próxima tentativa, mesmo
        // com a senha certa, cai na rota padrão em vez do destino original.
        const isLoginRequest = req.url.includes('/auth/login');
        if (err.status === 401 && !isLoginRequest) {
          this.auth.logout();
          this.router.navigate(['/auth/login']);
        }
        return throwError(() => err);
      })
    );
  }
}
